import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { company, navigation } from "../data/company";
import { services } from "../data/services";
export function Footer() {
  return <footer className="w-full px-3 pb-3 lg:px-5 lg:pb-5" data-id="element-18" data-mp="32ovwwtntqrjm">
      <div className="mx-auto max-w-[1440px] rounded-3xl bg-ink px-6 py-14 text-white lg:px-14" data-id="element-19" data-mp="36pft9v0kpr4p">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]" data-id="element-20" data-mp="3uf0phflqmkvx">
          <div data-id="element-21" data-mp="3uftkxkf8xnyr">
            <Logo inverted data-id="element-22" data-mp="3ud7i1y3avwmv" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/65" data-id="element-23" data-mp="398zqhbvha9n">
              Artisan peintre et vitrier installé à Meaux. Travaux de peinture, vitrerie et enduits de façade pour particuliers et professionnels.
            </p>
          </div>

          <nav aria-label="Plan du site" data-id="element-24" data-mp="3qfjgwdb0l7mj">
            <h2 className="text-sm font-bold text-white" data-id="element-25" data-mp="29ynjtg85axbw">Navigation</h2>
            <ul className="mt-4 space-y-3" data-id="element-26" data-mp="2ey9zrxfcyroe">
              {navigation.map(item => <li key={item.to} data-id="element-27" data-mp="2evx8uurmh6z7">
                  <Link to={item.to} className="text-sm text-white/65 transition-colors duration-150 hover:text-white" data-id="element-28" data-mp="3l90pe0juz71d">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-29" data-mp="3v91bfu944199">
            <h2 className="text-sm font-bold text-white" data-id="element-30" data-mp="3v5dfkog732rd">Prestations</h2>
            <ul className="mt-4 space-y-3" data-id="element-31" data-mp="3q727ai5jt0b9">
              {services.map(s => <li key={s.id} data-id="element-32" data-mp="81pfpjtqwz9w">
                  <Link to="/prestations" className="text-sm text-white/65 transition-colors duration-150 hover:text-white" data-id="element-33" data-mp="80xiy5oewvi1">
                    {s.title}
                  </Link>
                </li>)}
              <li data-id="element-34" data-mp="ctqo2unsm5un">
                <Link to="/prestations" className="text-sm text-white/65 transition-colors duration-150 hover:text-white" data-id="element-35" data-mp="ct76xg5yvlho">
                  Rénovation intérieure
                </Link>
              </li>
            </ul>
          </div>

          <address className="not-italic" data-id="element-36" data-mp="mthkj1vwyuxd">
            <h2 className="text-sm font-bold text-white" data-id="element-37" data-mp="tv4o84h2f862">Entreprise</h2>
            <p className="mt-4 text-sm leading-relaxed text-white/65" data-id="element-38" data-mp="twxqz8ok588s">
              {company.manager}
              <br data-id="element-39" data-mp="ys3g0gd9b313" />
              {company.address}
              <br data-id="element-40" data-mp="13t0sccbl52uo" />
              {company.city}
            </p>
            <p className="mt-4 text-sm text-white/65" data-id="element-41" data-mp="18k0qfkwfxqyr">SIRET {company.siret}</p>
          </address>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-white/50 sm:flex-row sm:items-center sm:justify-between" data-id="element-42" data-mp="1clunlj7fgcu6">
          <p data-id="element-43" data-mp="1hj4e726jyujl">© {new Date().getFullYear()} {company.name} — {company.status}. Tous droits réservés.</p>
          <Link to="/contact" className="transition-colors duration-150 hover:text-white" data-id="element-44" data-mp="1mkjwimhcimya">
            Mentions légales
          </Link>
        </div>
      </div>
    </footer>;
}